import { AxiosError } from "axios";

function getStatus(error: unknown): number | undefined {
  return error instanceof AxiosError ? error.response?.status : undefined;
}

export function isUnauthorized(error: unknown): boolean {
  return getStatus(error) === 401;
}
export function isForbidden(error: unknown): boolean {
  return getStatus(error) === 403;
}

export function isNotFound(error: unknown): boolean {
  return getStatus(error) === 404;
}
export function isBadRequest(error: unknown): boolean {
  return getStatus(error) === 400;
}
export function isServerError(error: unknown): boolean {
  const status = getStatus(error);
  return status !== undefined && status >= 500 && status < 600;
}

export function isClientError(error: unknown): boolean {
  const status = getStatus(error);
  return status !== undefined && status >= 400 && status < 500;
}
